/**
 * Returns a URL friendly slug
 *
 * @param a string
 * @returns a slugified string
 *
 * exmaple:
 * param 'Reason & Physical Info'
 * returns: 'reason-physical-info'
 *
 */
export const slugify = (str: string) => {
	return str
		.toLowerCase()
		.replace(/[^a-z0-9]/g, '-') // remove all except alphanumerics & replace all with '-'
		.replace(/-+/g, '-'); // collapse dashes
};
